// Политика ссылок дизайн-блока (contract §4.3): бек принимает только https.
// http, protocol-relative и прочие схемы дают 422 на запись и пустую строку на
// чтение, а `javascript:`/`data:` не должны уезжать в DOM вовсе — нарисовав такую
// ссылку, студия обещала бы автору картинку, которая исчезнет после сохранения.

/** Пригодный для `src` https-URL или null. Никогда не бросает: значение приходит
 *  из данных автора и может быть не URL вообще. */
export const httpsMediaSrc = (url: string): string | null => {
  try {
    const parsed = new URL(url)
    return parsed.protocol === 'https:' ? parsed.toString() : null
  } catch {
    return null /* не URL — ссылку не отдаём */
  }
}
